import TextCell from "./TextCell";
import LongTextCell from "./LongTextCell";
import NumberCell from "./NumberCell";
import StatusCell from "./StatusCell";
import PeopleCell from "./PeopleCell";
import DateCell from "./DateCell";
import DropdownCell from "./DropdownCell";
import CheckboxCell from "./CheckboxCell";
import RatingCell from "./RatingCell";
import LinkCell from "./LinkCell";
import EmailCell from "./EmailCell";
import PhoneCell from "./PhoneCell";
import TagsCell from "./TagsCell";
import FileCell from "./FileCell";
import TimelineCell from "./TimelineCell";
import FormulaCell from "./FormulaCell";

import React from "react";

export const cellComponents = {
  text: TextCell,
  long_text: LongTextCell,
  number: NumberCell,
  status: StatusCell,
  people: PeopleCell,
  date: DateCell,
  dropdown: DropdownCell,
  checkbox: CheckboxCell,
  rating: RatingCell,
  link: LinkCell,
  email: EmailCell,
  phone: PhoneCell,
  tags: TagsCell,
  file: FileCell,
  timeline: TimelineCell,
  formula: FormulaCell,
};

export function CellRenderer({ column, ...rest }) {
  const C = cellComponents[column.type];
  if (!C) {
    return <div className="cell-display unknown">[{column.type}]</div>;
  }
  // `item` and `boardId` are forwarded for cells that need to call APIs
  // beyond the simple column-value pipe (e.g. FileCell uploads).
  return <C column={column} {...rest} />;
}
